import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { useDispatch } from "react-redux";
import { descriptionvalidation } from "../../../Common/commonvalidation";

export default function ProfileModelAbout({
  edittype,
  formData,
  setFormData,
  setModelAbout,
}) {
  const dispatch = useDispatch();
  const initialValues = {
    about: formData?.expert?.about || "",
    // national_id: formData?.expert?.national_id || '',
    designation: formData?.expert?.designation || "",
  };

  const validationSchema = Yup.object().shape({
    about: descriptionvalidation,
    // national_id: Yup.string().trim().required('This Field is Required').test('not-only-spaces', 'Please enter a valid value', value => value.trim() !== ''),
    designation: descriptionvalidation,
  });

  const handleSubmit = (values) => {
    const data = {
      type: "expert_about",
      about: values.about,
      // national_id: values.national_id,
      designation: values.designation,
    };
    if (edittype == 1) {
      dispatch(updateProfile(data));
      setModelAbout((state) => !state);
    } else {
      setFormData({
        ...formData,
        about: values.about,
        national_id: values.national_id,
        designation: values.designation,
      });
      setModelAbout((state) => !state);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <>
          <button
            onClick={() => setModelAbout((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <Form>
            <ModalBody>
              <h4>Edit Profile</h4>
              <div className="form-group">
                <label className="label-s">About</label>
                <Field
                  as="textarea"
                  className="form-control input"
                  name="about"
                  placeholder="Tell us about yourself"
                />
                <ErrorMessage name="about" component="div" className="error" />
              </div>
              {/* <div className='form-group'>
                <label className='label-s'>National ID</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="national_id"
                  placeholder='Your National ID'
                />
                <ErrorMessage name="national_id" component="div" className="error" />
              </div> */}
              <div className="form-group">
                <label className="label-s">Designation</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="designation"
                  placeholder="Your Designation"
                />
                <ErrorMessage
                  name="designation"
                  component="div"
                  className="error"
                />
              </div>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button className="btn" type="submit">
                Save
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
